export enum StaticFileVariantKey {
  Pdf = 'pdf',
  FirstPageOfPdfImage = 'first-page-of-pdf-image',
  VideoScreenshot = 'video-screenshot',
  AudioWaveform = 'audio-waveform',
  CompressedImage = 'compressed-image',
  CompressedImageWebp = 'compressed-image-webp',
  AnimatedImage = 'animated-image',
  LivePhotoVideo = 'live-photo-video',
  VideoFramePreview = 'frame-preview',
  VideoNativeResolution = 'video-native-resolution',
  VideoHighestProcessedQuality = 'highest-processed-quality',
  ContentText = 'content-text',
  Description = 'description',
  ContentOcrText = 'content-ocr-text',
  ContentVision = 'content-vision',
  ContentTranscript = 'content-transcript',
  ContentTable = 'content-table',
}
